import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageBrowser } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public currentUser = new BehaviorSubject<any>(null);

  constructor(private storageBrowser: StorageBrowser) {
    const savedUser = this.storageBrowser.get('user');
    if (savedUser) {
      this.currentUser.next(savedUser);
    }
  }

  updateUserData(userData: any) {
    this.storageBrowser.set('user', userData);
    this.currentUser.next(userData);
  }
}
